var map = {
	"./music-instructions.json": 5188,
	"./music-library-intro2024.json": 5189,
	"./music-library-launch2024.json": 5190,
	"./music-progression.json": 5191,
	"./startSourcesAdvanced.json": 5192,
	"./startSourcesSimple.json": 5193,
	"./startSourcesSimple2.json": 5194,
	"./startSourcesTracks.json": 5195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4796;